module.exports = __webpack_public_path__ + "static/media/watch-calculator.5b31814d.svg";